<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">2022世界人工智能大会最高奖项公布，腾讯「探星计划」荣获SAIL之星</div>
      <div class="news-date">2022年9月1日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          9月1日，
          <span class="mark-text">2022世界人工智能大会（WAIC）</span>
          在上海正式开幕。在开幕式上，
          <span class="mark-text">2022世界人工智能大会最高奖项“SAIL奖”</span>
          也正式官宣。经过初评、复评、终评等多轮角逐，最终从800多个全球项目中评选出了5个SAIL大奖，6个SAIL之星和TOP30榜单项目。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news21.jpeg"/>
          </div>
        </div>
        <p>
          其中，来自腾讯优图实验室联合国家天文台的
          <span class="mark-text high-light">“AI探星计划暨联合中国天眼FAST的新天体搜索”</span>
          项目荣获
          <span class="mark-text high-light">“SAIL 之星”</span>
          奖。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news21_1.png"/>
          </div>
        </div>
        <p>作为世界人工智能大会的最高奖项，SAIL奖也常常被人们认为是人工智能界业的“奥斯卡”奖。SAIL奖坚持“追求卓越、引领未来”的理念，从全球范围发掘在人工智能领域中具有高度认可和美誉、并具有提升人类福祉意义的项目，深受业内人士关注和认可。</p>
        <div class="intro">
          <div class="mark-text intro-title">SAIL奖</div>
          <p class="intro-text">“S”即“Superior”，代表了“超越”，表明了奖项在行业内卓越引领的地位；“A”即“Applicative”，代表了“赋能”，彰显了奖项注重人工智能技术对经济社会应用赋能的极高期许；“I”即“Innovative”，代表了“创新”，突显了奖项评选对项目理论与技术层面的创新要求；“L”即“Leading”，代表了“引领”，展现了奖项对标的是全球人工智能领域内最具引领性的开路先锋。</p>
        </div>
        <p>
          在2021世界人工智能大会上，腾讯公司董事会主席兼首席执行官马化腾宣布，腾讯将和国家天文台共同启动
          <span class="mark-text high-light">“探星计划”</span>
          ，利用腾讯优图实验室领先的AI技术、腾讯云的强大算力，帮助
          <span class="mark-text high-light">中国天眼FAST</span>
          处理海量的观测数据，一起探索宇宙奥秘。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news21_2.jpeg"/>
          </div>
        </div>
        <p>此次获奖，不仅是对“探星计划”的成果肯定，更是对腾讯优图实验室AI技术水平高度的证明。</p>
        <p>
          “探星计划”启动以来，利用腾讯优图实验室领先的AI技术、腾讯云的强大算力，AI对信号的处理效率提高了120倍。在较短时间内，已快速发现了数十颗脉冲星，整体发现效率行业领先。目前，项目成果已经在多个国际著名学术会议和期刊上发表。
          <span class="mark-text">FAST+AI，将助力中国天文取得更多成果。</span>
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news21_3.jpeg"/>
          </div>
        </div>
        <p>未来，腾讯优图实验室也将持续探索AI可持续发展之道，深度融合计算机视觉技术与新天体探索领域，仰望头顶星空，叩问宇宙的奥秘。</p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News21',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .high-light {
    color: rgb(1, 82, 217);
  }
  .intro {
    margin: 15px 0;
    padding: 16px;
    box-shadow: rgb(1, 82, 217) 4px 4px 0px;
    background-color: rgba(55, 113, 187, 0.06);
    border-style: solid;
    border-width: 1px;
    border-color: rgb(1, 82, 217);
    position: relative;
    .intro-title {
      position: absolute;
      left: 28px;
      top: -17px;
      width: 72px;
      height: 28px;
      background-color: #fff;
      color: rgb(1, 82, 217);
      text-align: center;
      line-height: 28px;
    }
    p.intro-text {
      color: rgb(89, 89, 89);
      padding: 0;
      font-size: 15px;
      line-height: 25px;
      font-family: PingFangSC-light;
    }
  }
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News21.vue